import type { RootState } from '../';

export function isCompanyValid(
  state: RootState,
  name: string,
): 'valid' | 'invalid' | 'in_progress' | 'unknown' {
  const item = state.companySearch.valid[name];
  if (item) {
    return item.state;
  } else {
    return 'unknown';
  }
}

export function getItems(state: RootState, term: string) {
  const result = state.companySearch.search[term];
  if (result?.state === 'finished') {
    return result.items;
  } else {
    return [];
  }
}
